import { render, staticRenderFns } from "./TablePortals.vue?vue&type=template&id=7d707fb9"
import script from "./TablePortals.vue?vue&type=script&lang=js"
export * from "./TablePortals.vue?vue&type=script&lang=js"
import style0 from "./TablePortals.vue?vue&type=style&index=0&id=7d707fb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports